import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const ChatError = () => (
  <div className="flex size-full flex-col items-center justify-center">
    <Typography.LabelSm>{t("chat_space.error_message")}</Typography.LabelSm>
  </div>
);
